import $ from 'jquery';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { formatMatchType } from '@bingads-webui-campaign/recommendation-core';
import { InlineEditableColumnPrompt } from './match-type-inline-editable/prompt';

export class MatchTypeSelectorColumnVNext extends CampaignuiBaseColumn {
  constructor({ i18n, deps, view }) {
    const title = i18n.getString('Details_View_Match_Type') || '__Match type__';

    super({
      name: 'matchType',
      property: 'Opportunities/MatchType',
      title,
      bodyClasses: ['grid-column-matchType', 'actionable'],
      colClasses: ['col-matchType'],
      sortable: 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.KeywordOpportunitySummary/MatchTypeStr',
      helpId: 'Pop_BA_Recommendations_MatchType',
      type: 'string',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.deps = deps;
    this.view = view;
  }

  pickProperty(item) {
    const matchType = item.Opportunities[0].NewMatchType || item.Opportunities[0].MatchType;
    return matchType ? formatMatchType(matchType, this.i18n) : '';
  }
  onPrompt({
    event,
    item,
    newPosition,
  }) {
    InlineEditableColumnPrompt({
      position: newPosition,
      item,
      view: this.view,
      i18n: this.i18n,
      key: $(event.target).parents('tr[data-key]').data('key'),
    });
  }
}
